import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SimplePriceInfoComponent } from './simple-price-info.component';

@NgModule({
  imports: [CommonModule],
  declarations: [SimplePriceInfoComponent],
  exports: [SimplePriceInfoComponent]
})
export class SimplePriceInfoModule {}
